import { render, staticRenderFns } from "./ConfigurationCard.vue?vue&type=template&id=27bd78c4&scoped=true&"
import script from "./ConfigurationCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationCard.vue?vue&type=style&index=0&id=27bd78c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd78c4",
  null
  
)

export default component.exports